import { client } from './client'

export function fetchAvailableLanguagesRequest() {
  return client.get('/languages')
}
